import { useRouter, useSearch } from '@tanstack/react-router'
import { FormPageLayout, Surface } from '../components'
import { LoginFormContainer } from '@/components/organisms'

export default function Login() {
    const router = useRouter()
    const { redirectTo } = useSearch({
        from: '/login/',
    })

    return (
        <FormPageLayout videoSrc="assets/login.mp4">
            <Surface className="max-lg:bg-white/85" padding="large">
                <LoginFormContainer
                    onSuccess={() => {
                        if (redirectTo) {
                            const parsedUrl = decodeURIComponent(redirectTo)
                            const url = new URL(
                                parsedUrl,
                                window.location.origin
                            )
                            const searchParams = Object.fromEntries(
                                url.searchParams.entries()
                            )
                            void router.navigate({
                                to: url.pathname,
                                search: searchParams,
                            })
                        } else {
                            void router.navigate({ to: '/' })
                        }
                    }}
                />
            </Surface>
        </FormPageLayout>
    )
}
